import React, { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { VideoModal } from "../VideoModal";

const POLLING_INTERVAL = 60000;
const endpoint = process.env.REACT_APP_API_URL + '/api/show_video';

export const ShowVideoModal = () => {
    const userId = useSelector((state) => state.auth.user.id);
    const [video, setVideo] = useState(null);
    const intervalRef = useRef(null);

    const fetchVideo = async () => {
        const response = await fetch(endpoint + '?user=' + userId);
        const data = await response.json();
        if (response.ok) {
            stopInterval();
            setVideo(data);
        }
    };

    const stopInterval = () => {
        if (intervalRef.current) {
            clearInterval(intervalRef.current);
            intervalRef.current = null;
        }
    };

    const startInterval = () => {
        if (intervalRef.current) return;
        fetchVideo();
        intervalRef.current = setInterval(fetchVideo, POLLING_INTERVAL);
    };

    const handleClose = () => {
        setVideo(null);
        startInterval();
    };

    useEffect(() => {
        startInterval();
        return () => stopInterval();
    }, []);

    return <VideoModal video={video} onClose={handleClose} />;
};
